import React, { useState } from 'react';
import {
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from '@material-ui/core';
import { useUserProfile } from '@backstage/plugin-user-settings';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { oidcAuthApiRef } from '../../apis';

import InfoIcon from '@material-ui/icons/Info';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

const UserProfileInfo: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const configApi = useApi(configApiRef);
  const oidcAuthApi = useApi(oidcAuthApiRef);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleMenuClose();

    const baseUrl = configApi.getString('app.baseUrl');
    const logoutUrl = configApi.getOptionalString('app.auth.oidcLogoutUrl');
    const clientId =
      configApi.getOptionalString('app.auth.oidcClientId') ?? 'backstage-client';

    // Sign out from Backstage session first
    await oidcAuthApi.signOut();

    if (logoutUrl) {
      // Redirect to Keycloak logout endpoint to also clear the IDP session,
      // preventing auto re-login on the next OIDC redirect
      const params = new URLSearchParams({
        client_id: clientId,
        post_logout_redirect_uri: baseUrl,
      });
      window.location.href = `${logoutUrl}?${params.toString()}`;
    } else {
      // Fallback: reload to the app base URL
      window.location.href = baseUrl;
    }
  };

  const { displayName } = useUserProfile();

  return (
    <>
      <IconButton
        onClick={handleMenuOpen}
        edge="end"
        color="inherit"
        aria-label="Account"
      >
        <PersonOutlineIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        getContentAnchorEl={null}
      >
        <MenuItem onClick={handleMenuClose}>
          <ListItemIcon>
            <InfoIcon />
          </ListItemIcon>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subtitle1">{displayName}</Typography>
          </div>
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <ExitToAppIcon />
          </ListItemIcon>
          <Typography variant="subtitle1">Sign Out</Typography>
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserProfileInfo;
